<template>
  <footer class="foot">
    <ul class="xdf_help">
      <li>
        <h3>关于新东方</h3>
        <a href="http://www.xdf.cn/zhuanti/help/develop.html" target="_blank">发展历程</a>
        <a href="http://www.xdf.cn/zhuanti/help/team.html" target="_blank">管理团队</a>
        <a href="http://www.xdf.cn/zhuanti/help/culture.html" target="_blank">企业文化</a>
        <a href="http://www.xdf.cn/zhuanti/help/brand.html" target="_blank">旗下品牌</a>
        <a href="http://t.xdf.cn/" target="_blank">企业微博</a>
        <a href="http://zhaopin.xdf.cn/" target="_blank">加入我们</a>
      </li>
      <li>
        <h3>新手帮助</h3>
        <a href="http://www.xdf.cn/zhuanti/help/register.html" target="_blank">注册流程</a>
        <a href="http://www.xdf.cn/zhuanti/help/select.html" target="_blank">选课流程</a>
        <a href="http://www.xdf.cn/zhuanti/help/signup.html" target="_blank">网报流程</a>
        <a href="http://souke.xdf.cn/Campus/0.html" target="_blank">校区和报名点查询</a>
      </li>
      <li>
        <h3>常见问题</h3>
        <a href="http://www.xdf.cn/zhuanti/help/number.html" target="_blank">学员号</a>
        <a href="http://www.xdf.cn/zhuanti/help/card.html" target="_blank">一卡通</a>
      </li>
      <li>
        <h3>支付方式</h3>
        <a href="http://www.xdf.cn/zhuanti/help/internetpay.html" target="_blank">网上支付</a>
        <a href="http://www.xdf.cn/zhuanti/help/pay.html" target="_blank">现场支付</a>
        <a href="http://www.xdf.cn/zhuanti/help/phonepay.html" target="_blank">电话支付</a>
        <a href="http://www.xdf.cn/zhuanti/help/remit.html" target="_blank">汇款支付</a>
        <a href="http://www.xdf.cn/zhuanti/help/telephonepay.html" target="_blank">手机支付</a>
      </li>
      <li>
        <h3>联系我们</h3>
        <a href="http://www.xdf.cn/zhuanti/help/phonenumber.html" target="_blank">校区电话</a>
        <a href="http://www.xdf.cn/zhuanti/help/suggestion.html" target="_blank">意见建议</a>
        <a href="http://www.xdf.cn/zhuanti/help/email.html" target="_blank">联系邮箱</a>
      </li>
      <li>
        <h3>企业官网</h3>
        <a href="http://www.xdf.cn/about/law.html" target="_blank">法律声明</a>
        <a href="http://www.xdf.cn/brand/index.html" target="_blank">社会责任</a>
      </li>
    </ul>
    <div class="authentication">
      <div class="authentication-top">
        <p>
          经营许可证编号：京ICP备05067667 | 京ICP证060601号| 京网文(2016)5762-750号 |
          <img src=" http://www.xdf.cn/zhuanti/beiantubiao/batb.png" />
          京公网安备11010802021790号
        </p>
        <p>Copyright © 2011-2018 Neworiental Corporation, All Rights Reserved</p>
      </div>
      <div class="authentication-bottom">
        <a href="https://credit.szfw.org/CX20170816035600880387.html" target="_blank">
          <img src="http://icon.szfw.org/sf.png" border="0">
        </a>
        <a href="https://ss.knet.cn/verifyseal.dll?sn=2011050300100008297&ct=df&a=1pa=0.12573011522181332" target="_blank">
          <img src="http://file.xdf.cn/201501/cnnic.png" alt="可信网站">
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Commonfoot'
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
  .foot
    background: #f6f6f6
    padding-top: 10px
    .xdf_help
      width: $defaultwidth
      margin: 10px auto 32px
      display: flex
      padding: 4px 0 20px 0
      border-bottom: 1px solid #e0e0e0
      clear:both
      height:170px
      justify-content: space-between
      li
        display: flex
        flex-direction: column
        text-align: left
        float :left
        h3
          line-height: 30px
          font-size: 16px
          color: #606060
        a
          color: #999
          line-height: 22px
          font-size: 14px
          display block
          &:hover
            color: $titbgcolor
    .authentication
      text-align: center
      .authentication-top
        padding: 5px 0
        p
          line-height: 26px
          color: #999
</style>



// WEBPACK FOOTER //
// src/common-components/CommonFooter.vue